module.exports = __webpack_public_path__ + "img/yunicu-logo.9bca5c94.png";